import { useCallback, useState } from 'react';
import { useEventManagementService } from '../services/eventManagementService';

/**
 * Loads the raw event behind a rule's newest action log item into the editor's
 * test event. `ruleId` is null for a rule that has not been saved yet.
 */
export function useRuleSampleEvent(
  customerId: string,
  ruleId: string | null,
  onEvent: (event: Record<string, unknown>) => void,
  onError: (message: string) => void,
) {
  const eventService = useEventManagementService();
  const [loading, setLoading] = useState(false);

  const loadLatest = useCallback(async () => {
    if (!ruleId) return;
    setLoading(true);
    try {
      const sample = await eventService.getRuleSampleEvent({ customer_id: customerId, rule_id: ruleId });
      onEvent(sample.event);
    } catch (err) {
      onError(err instanceof Error ? err.message : 'Failed to load the latest event');
    } finally {
      setLoading(false);
    }
  }, [customerId, ruleId, eventService, onEvent, onError]);

  return { loadLatest, loading };
}
